import { Header } from "./components/Header";
import { Introduction } from "./components/Introduction";
import { AboutMe } from "./components/AboutMe";
import { Experience } from "./components/Experience";
import { MyWorkTools } from "./components/MyWorkTools";
import { Contact } from "./components/Contacts";

import "./styles/global.scss";
import { Footer } from "./components/Footer";
import initAnimacaoScroll from "./modules/scroll-suave";

function App() {
  window.addEventListener("scroll", initAnimacaoScroll);

  return (
    <>
      <Header />
      <Introduction />
      <AboutMe />
      <Experience />
      <MyWorkTools />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
